import { http } from "@/configurations/axios";

const BASE_URL = "/envio-contabilidade";

const unwrap = response => response.data;

const withParams = params => ({
  params: params || {},
});

const toConfigPayload = (configuracao, overrides = {}) => ({
  nome: configuracao.nome,
  ativo: configuracao.ativo,
  emails: configuracao.emails || [],
  cc: configuracao.cc || [],
  bcc: configuracao.bcc || [],
  dia_mes: configuracao.dia_mes,
  horario: "07:00",
  timezone: configuracao.timezone || "America/Sao_Paulo",
  periodo: configuracao.periodo || "mes_anterior",
  itens: configuracao.itens || {},
  enviar_sem_movimento: Boolean(configuracao.enviar_sem_movimento),
  assunto_email: configuracao.assunto_email || "",
  mensagem_email: configuracao.mensagem_email || "",
  ...overrides,
});

export default {
  listarConfiguracoes(params = {}) {
    return http.get(`${BASE_URL}/configs`, withParams(params)).then(unwrap);
  },

  criarConfiguracao(payload) {
    return http.post(`${BASE_URL}/configs`, payload).then(unwrap);
  },

  editarConfiguracao(id, payload) {
    return http.put(`${BASE_URL}/configs/${id}`, payload).then(unwrap);
  },

  excluirConfiguracao(id) {
    return http.delete(`${BASE_URL}/configs/${id}`).then(unwrap);
  },

  alterarStatusConfiguracao(configuracao, ativo) {
    return this.editarConfiguracao(
      configuracao.id,
      toConfigPayload(configuracao, { ativo })
    );
  },

  desativarConfiguracao(configuracao) {
    return this.alterarStatusConfiguracao(configuracao, false);
  },

  listarItens() {
    return http.get(`${BASE_URL}/itens`).then(unwrap);
  },

  listarExecucoes(params = {}) {
    return http.get(`${BASE_URL}/execucoes`, withParams(params)).then(unwrap);
  },

  detalharExecucao(id) {
    return http.get(`${BASE_URL}/execucoes/${id}`).then(unwrap);
  },

  executarAgora(configuracaoId) {
    return http
      .post(`${BASE_URL}/configs/${configuracaoId}/executar-agora`)
      .then(unwrap);
  },

  enviarTeste(configuracaoId) {
    return http
      .post(`${BASE_URL}/configs/${configuracaoId}/enviar-teste`)
      .then(unwrap);
  },

  reenviar(execucaoId, payload = {}) {
    return http
      .post(`${BASE_URL}/execucoes/${execucaoId}/reenviar`, payload)
      .then(unwrap);
  },

  baixarPacote(execucaoId) {
    return http.get(`${BASE_URL}/execucoes/${execucaoId}/download`).then(unwrap);
  },
};
